import { isStringValid } from "core-lib/utils/utils";

export enum CdnTypes {
  ImageKit = "ImageKit",
}

export enum Products {
  Community = "Community",
  Strapi = "Strapi",
  ImageKit = "ImageKit",
}

export const ProductUrlMapping = {
  Community: {
    baseUrl:
      "https://parkplus-bkt-img.parkplus.io/production/social-community/public/",
    newBaseUrl: "https://parkplus-bkt-img.parkplus.io/production/social-community/public/",
  },
  Strapi: {
    baseUrl: "https://strapi-file-uploads.s3.ap-south-1.amazonaws.com/",
    newBaseUrl: "https://ik.imagekit.io/parkplus/",
  },
  ImageKit: {
    baseUrl: "https://ik.imagekit.io/parkplus/",
    newBaseUrl: "https://ik.imagekit.io/parkplus/",
  },
};

export function getImageKitUrl({
  imageUrl,
  product = Products.ImageKit,
  cdnType = CdnTypes.ImageKit,
  width = null,
  height = null,
  quality = null,
  blurred = null,
}: {
  imageUrl: string;
  product?: keyof typeof Products;
  cdnType?: keyof typeof CdnTypes;
  width?: number;
  height?: number;
  quality?: number;
  blurred?: number;
}) {
  return imageUrl;
  // if (!isStringValid(imageUrl)) return imageUrl;
  // if (
  //   cdnType === CdnTypes.ImageKit &&
  //   imageUrl.includes(ProductUrlMapping[product].baseUrl)
  // ) {
  //   const newImageUrl = imageUrl
  //     .trim()
  //     .replace(
  //       ProductUrlMapping[product].baseUrl,
  //       ProductUrlMapping[product].newBaseUrl
  //     );
  //   let query = "";
  //   if (width) {
  //     query += `w-${width},`;
  //   }
  //
  //   if (height) {
  //     query += `h-${height},`;
  //   }
  //
  //   if (quality) {
  //     query += `q-${quality},`;
  //   }
  //
  //   if (blurred) {
  //     query += `bl-${blurred}`;
  //   }
  //
  //   return query.length > 0
  //     ? newImageUrl.includes("?tr=")
  //       ? newImageUrl.concat(",", query)
  //       : newImageUrl.concat("?tr=", query)
  //     : newImageUrl;
  // } else {
  //   return imageUrl;
  // }
}
